// extracted by mini-css-extract-plugin
export var blockBtn = "courseSummary-module--block-btn--d2461";
export var courseSummary = "courseSummary-module--course-summary--2a6bc";
export var courseSummary__image = "courseSummary-module--course-summary__image--9aa39";
export var courseSummary__list = "courseSummary-module--course-summary__list--580f8";
export var courseSummary__listItem = "courseSummary-module--course-summary__list-item--6396f";
export var courseSummary__listItemOne = "courseSummary-module--course-summary__list-item--one--82913";
export var courseSummary__listItemThree = "courseSummary-module--course-summary__list-item--three--a08d6";
export var courseSummary__listItemTwo = "courseSummary-module--course-summary__list-item--two--89dd7";
export var courseSummary__mark = "courseSummary-module--course-summary__mark--c7d6e";
export var courseSummary__title = "courseSummary-module--course-summary__title--93b6b";
export var courseSummary__wrapper = "courseSummary-module--course-summary__wrapper--49cd4";
export var mainBtn = "courseSummary-module--main-btn--aefd3";
export var mainTitle = "courseSummary-module--main-title--ef1b7";
export var title = "courseSummary-module--title--c7583";